import { useMemo } from 'react'

import {
  VerticalAlignBottomOutlined,
  VerticalAlignMiddleOutlined,
  VerticalAlignTopOutlined
} from '@ant-design/icons'
import { Dropdown } from 'antd'

import { BasicProps } from '@eastcoal/common/types/component'

import { useTableForced } from '../../hooks/useTableForced'
import {
  useTableVerticalAlign,
  VerticalAlignType
} from '../../hooks/useTableVerticalAlign'
import { DropdownButton } from '../../ui/DropdownButton'

const items = [
  {
    key: 'top',
    label: '顶部对齐',
    icon: <VerticalAlignTopOutlined />
  },
  {
    key: 'middle',
    label: '垂直居中',
    icon: <VerticalAlignMiddleOutlined />
  },
  {
    key: 'bottom',
    label: '底部对齐',
    icon: <VerticalAlignBottomOutlined />
  }
]

export const TableVerticalAlignDropdown = (props: BasicProps) => {
  const [verticalFormat, setVerticalFormat] = useTableVerticalAlign()
  const selectedItem = items.find(item => item.key === verticalFormat)
  const selectedKeys = useMemo(() => [verticalFormat], [verticalFormat])

  const tableForced = useTableForced()

  return tableForced ? (
    <Dropdown
      menu={{
        items,
        selectedKeys,
        onClick: ({ key }) => {
          setVerticalFormat(key as VerticalAlignType)
        }
      }}
    >
      <DropdownButton {...props} tooltip={selectedItem?.label}>
        {selectedItem?.icon}
      </DropdownButton>
    </Dropdown>
  ) : null
}
